"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * 
 * @param {*} token 
 * @param {*} index 
 */
var concatTokens = function concatTokens(token, index) {
  if (index === undefined || null) {
    index = 1;
  }
  var a = token.toString() + index.toString();
  a = a.toLowerCase().replace(/[. ,:-]+/g, "-");
  return a;
};
var _default = exports["default"] = concatTokens;